import { useEffect, useState, useContext } from 'react'
import I18n from 'i18n-js'
import { useHistory, useParams, Link } from 'react-router-dom'
import {
  Box,
  Grid,
  Typography,
  Button,
  CircularProgress,
  Chip,
} from '@mui/material'
import { Card } from '@mui/material'

import { CrudsBtn } from '../../../components'
import { showCoordinatingStaff } from '../../../services/coordinatingStaff'
import { AuthContext } from '../../../context/auth'
import { canAccess } from '../../../router/permissions'
import { actionKeys, pagesKeys } from '../../../utils'
import { Icons } from '../../../utils'
import useStyles from './styles'
import { dateFormat } from '../../../utils/date'

const Show = () => {
  const classes = useStyles()
  const params = useParams()

  //state
  const { state } = useContext(AuthContext)
  const history = useHistory()
  const [data, setData] = useState(null)

  //permissions
  const pageId = pagesKeys.coordinatingStaff

  useEffect(() => {
    if (!canAccess(actionKeys.detail, pageId, state)) {
      history.push('/dashboard')
      return
    }
    const getData = async () => {
      if (params.id) {
        const res = await showCoordinatingStaff(params.id)
        const coordinator = res?.data?.coordinatingStaff
        if (coordinator) setData(coordinator)
        else history.push('/dashboard/coordinating-staff')
      }
    }
    getData()
  }, [])

  if (!data)
    return (
      <Box p={4}>
        <CircularProgress className={classes.circularProgress} />
      </Box>
    )

  const centers = data.medical_centers || []
  const isFemale = !data.sex || data.sex === 'Féminin' || data.sex === 'F'

  return (
    <Box p={4}>
      <Grid container spacing={2} direction="column">
        <Grid item>
          <Typography variant="body2" color="textSecondary">
            {I18n.t('breadcrumb.coordinatingStaff')} /{' '}
            <Link
              to="/dashboard/coordinating-staff"
              className={classes.textBreadcrum}
            >
              {I18n.t('breadcrumb.dashboard')}
            </Link>{' '}
            / {I18n.t('breadcrumb.detail')}
          </Typography>
        </Grid>
        <Grid item>
          <Grid container justifyContent="space-between">
            <Grid item>
              <Typography
                variant="h5"
                color="primary"
                style={{ textTransform: 'capitalize' }}
              >
                {data.name} {data.lastname}
              </Typography>
            </Grid>
            <Grid item>
              {canAccess(actionKeys.edit, pageId, state) && (
                <CrudsBtn
                  text={I18n.t('coordinatingStaff.edit')}
                  size="medium"
                  click={() =>
                    history.push(`${history.location.pathname}/edit`)
                  }
                />
              )}
            </Grid>
          </Grid>
        </Grid>

        <Grid item>
          <Card bgcolor="white">
            <Box p={4}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Typography variant="h6" color="primary">
                    {I18n.t('coordinatingStaff.form.personalInformation')}
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography variant="subtitle2">
                    {I18n.t('coordinatingStaff.form.first_name')}:
                  </Typography>
                  <Typography variant="body1">{data.name}</Typography>
                </Grid>

                <Grid item xs={3}>
                  <Typography variant="subtitle2">
                    {I18n.t('coordinatingStaff.form.last_name')}:
                  </Typography>
                  <Typography variant="body1">
                    {data.lastname
                      ? data.lastname
                      : I18n.t('general.dataNotFound')}
                  </Typography>
                </Grid>

                <Grid item xs={3}>
                  <Typography variant="subtitle2">
                    {I18n.t('coordinatingStaff.form.gender')}:
                  </Typography>
                  <Typography variant="body1">
                    {data.sex === null || data.sex === undefined
                      ? I18n.t('general.dataNotFound')
                      : isFemale
                      ? I18n.t('patient.form.gender.female')
                      : I18n.t('patient.form.gender.male')}
                  </Typography>
                </Grid>

                <Grid item xs={3}>
                  <Typography variant="subtitle2">
                    {I18n.t('coordinatingStaff.form.date_of_birth')}:
                  </Typography>
                  <Typography variant="body1">
                    {data.birth
                      ? dateFormat(String(data.birth).slice(0, 10))
                      : I18n.t('general.dataNotFound')}
                  </Typography>
                </Grid>

                <Grid item xs={3}>
                  <Typography variant="subtitle2">
                    {I18n.t('coordinatingStaff.form.phone_number')}:
                  </Typography>
                  <Typography variant="body1">
                    {data.phone ? data.phone : I18n.t('general.dataNotFound')}
                  </Typography>
                </Grid>

                <Grid item xs={3}>
                  <Typography variant="subtitle2">
                    {I18n.t('coordinatingStaff.form.mail_address')}:
                  </Typography>
                  <Typography variant="body1" className={classes.emailText}>
                    {data.email}
                  </Typography>
                </Grid>

                <Grid item xs={12}>
                  <Typography variant="h6" color="primary">
                    {I18n.t('coordinatingStaff.form.centersInformation')}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  {centers.length ? (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                      {centers.map((center) => (
                        <Chip key={center.id} label={center.name} />
                      ))}
                    </Box>
                  ) : (
                    <Typography variant="body1">
                      {I18n.t('general.dataNotFound')}
                    </Typography>
                  )}
                </Grid>

                <Grid item xs={12} style={{ marginTop: '20px' }}>
                  <Button
                    variant="outlined"
                    padding="8px 15px"
                    onClick={() => history.goBack()}
                    startIcon={Icons('arrow_back')}
                  >
                    {I18n.t('coordinatingStaff.back')}
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Card>
        </Grid>
      </Grid>
    </Box>
  )
}

export default Show
